export default "__VITE_ASSET__66ab7c4b__"